export const languages = [
  {
    code: "fa",
    shortForm: "فا",
    no: 1,
    name: "فارسی",
    dir: "rtl",
    country_code: "fa",
  },
  {
    code: "en",
    shortForm: "en",
    no: 2,
    name: "English",
    country_code: "gb",
  },
  {
    code: "ar",
    shortForm: "ع",
    no: 3,
    name: "العربية",
    dir: "rtl",
    country_code: "sa",
  },
  // {
  //   code: "de",
  //   shortForm: "de",
  //   no: 4,
  //   name: "German",
  //   country_code: "deDE",
  // },
  // {
  //   code: "fr",
  //   shortForm: "fr",
  //   no: 5,
  //   name: "France",
  //   country_code: "frFR",
  // },
  // {
  //   code: "zh",
  //   shortForm: "cn",
  //   no: 6,
  //   name: "Chinese",
  //   country_code: "zhCN",
  // },
  // {
  //   code: "ru",
  //   shortForm: "ru",
  //   no: 7,
  //   name: "Russian",
  //   country_code: "ruRU",
  // },
];

export const languagesAe = [
  {
    code: "en",
    shortForm: "en",
    no: 2,
    name: "English",
    country_code: "gb",
  },
  {
    code: "ar",
    shortForm: "ع",
    no: 3,
    name: "العربية",
    dir: "rtl",
    country_code: "sa",
  },
  // {
  //   code: "de",
  //   shortForm: "de",
  //   no: 4,
  //   name: "German",
  //   country_code: "deDE",
  // },
  // {
  //   code: "fr",
  //   shortForm: "fr",
  //   no: 5,
  //   name: "France",
  //   country_code: "frFR",
  // },
  // {
  //   code: "zh",
  //   shortForm: "cn",
  //   no: 6,
  //   name: "Chinese",
  //   country_code: "zhCN",
  // },
  // {
  //   code: "ru",
  //   shortForm: "ru",
  //   no: 7,
  //   name: "Russian",
  //   country_code: "ruRU",
  // },
];
